import { render, staticRenderFns } from "./GamesTab.vue?vue&type=template&id=5fac6014"
import script from "./GamesTab.vue?vue&type=script&lang=js"
export * from "./GamesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports